import { useTranslation } from 'react-i18next'
import { ChatMessage, SystemEventTypeEnum } from 'types/chat-message'

const SYSTEM_MESSAGE_KEYS: Record<SystemEventTypeEnum, string> = {
  [SystemEventTypeEnum.TICKET_CLOSED]: 'systemMessages.TICKET_CLOSED',
  [SystemEventTypeEnum.TICKET_REOPENED]: 'systemMessages.TICKET_REOPENED',
}

export const SystemMessage = ({ messageItem }: { messageItem: ChatMessage }) => {
  const { t } = useTranslation()
  const key = messageItem.systemEventType && SYSTEM_MESSAGE_KEYS[messageItem.systemEventType]
  // Unknown/future system events are hidden by design
  if (!key) return null

  return (
    <div className="tw-flex tw-justify-center">
      <span className="tw-rounded-full tw-bg-gray-100 tw-px-3 tw-py-1 tw-text-xs tw-text-gray-500">{t(key)}</span>
    </div>
  )
}
